import { useEffect } from 'react';

import { useAuthActions, useAuthState } from '#/features/auth/auth-context';
import { logException } from '#/features/logging/logging';

export function useJwtTokenRefreshHandler(refreshIntervalMs: number) {
  const [authState] = useAuthState();
  const authActions = useAuthActions();

  useEffect(() => {
    if (authState.token == null) {
      return;
    }

    const fetchJwtToken = async () => {
      const result = await authActions.performAuth();
      if (!result.ok && result.error != null) {
        const error = new Error('Failed refreshing JWT', {
          cause: result.error,
        });
        logException(error);
      }
    };

    const intervalId = setInterval(() => {
      fetchJwtToken().catch((err) => {
        const message = 'Unexpected Error in useJwtTokenRefresher';
        logException(new Error(message, { cause: err }));
      });
    }, refreshIntervalMs);

    return () => {
      clearInterval(intervalId);
    };
  }, [authActions, authState.token, refreshIntervalMs]);
}
